module.exports = __webpack_public_path__ + "assets/fonts/user-1.6972f7f6.svg";